import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CustomDataTable from './components/InboundDeliveryReport';
import Overlay from '../../Common/overlay';
/*import Table from '../../Tables/DataTable/components/DataTable';*/
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const InboundDeliveryReport = ({ t }) => (
  <Container>
    <Row>
     
      <CustomDataTable />
    </Row>

   
  </Container>
);

InboundDeliveryReport.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(InboundDeliveryReport);
